import { Dispatch } from 'redux';
import { batch } from 'react-redux';
import { ModalsDataTypes } from 'hooks/useModal';
import { ProposalProduct } from '@trnsact/trnsact-shared-types/src/generated';
import { deskingActions } from '../model';
import { defaultCashTerm } from '../constants';
import { AftermarketMenu, BuilderViewType, ProposalMenuId } from '../types';

interface Options {
  terms: number[];
  isCash: boolean;
  proposalMenuId: string;
  dispatch: Dispatch<any>;
  products: ProposalProduct[];
  proposalsProductsIds: string[];
  proposalMenus: Record<ProposalMenuId, AftermarketMenu>;
  handleOpen: (data?: ModalsDataTypes['deskingNotifyAboutRemovedProductsDialog']) => void;
}

export function setMenuDeps({
  terms,
  isCash,
  products,
  dispatch,
  handleOpen,
  proposalMenus,
  proposalMenuId,
  proposalsProductsIds,
}: Options) {
  const financeProgramTerms = isCash ? [defaultCashTerm].map(Number) : terms;

  dispatch(deskingActions.setMenuToBuilder({ id: proposalMenuId, terms: financeProgramTerms.map(String) }));

  const maxTerm = Math.max(...financeProgramTerms);

  batch(() => {
    dispatch(deskingActions.toggleIsEditEquipmentStatus({ status: true }));
    dispatch(deskingActions.setMenuTerm({ term: String(maxTerm), index: financeProgramTerms.lastIndexOf(maxTerm) }));
    dispatch(
      deskingActions.setProductsConfigFromExistingMenu({
        terms: financeProgramTerms.map(String),
        data: proposalMenus[proposalMenuId].menuOptions,
      })
    );
    dispatch(deskingActions.updateMenuBuilderViewType({ type: BuilderViewType.AftermarketMenu }));
  });

  const productsOnMenuFlat = proposalMenus[proposalMenuId].menuOptions.map(option => option?.products)?.flat() ?? [];

  const productsRemovedFromMenu = productsOnMenuFlat.reduce<ProposalProduct[]>((acc, product) => {
    if (
      !proposalsProductsIds.includes(product.proposalProductId) &&
      !products.find(p => p.aftermarketProduct?.productName === product.aftermarketProduct?.productName)
    ) {
      acc.push(product);
    }
    return acc;
  }, []);

  if (productsRemovedFromMenu.length) {
    handleOpen({ removedProducts: productsRemovedFromMenu });

    dispatch(
      deskingActions.removeProductsFromMenu({
        ids: productsRemovedFromMenu.map(({ proposalProductId }) => proposalProductId),
      })
    );
  }
}
